import { render, staticRenderFns } from "./decoration9.vue?vue&type=template&id=0fa88678&scoped=true"
import script from "./decoration9.vue?vue&type=script&lang=js"
export * from "./decoration9.vue?vue&type=script&lang=js"
import style0 from "./decoration9.vue?vue&type=style&index=0&id=0fa88678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa88678",
  null
  
)

export default component.exports